import PropTypes from 'prop-types'
import { useState, useEffect, Fragment } from 'react'
import MenuFiltros from '../MenuFiltros'
import ComponenteError from '../publicaciones/ComponenteError'
import * as presupuestosService from '../servicios/presupuestosService'
import BordePrincipal from '../ui/BordePrincipal'
import Presupuesto from './Presupuesto'

const Presupuestos = () => {
  const [presupuestos, setPresupuestos] = useState([])
  const [sinResultados, setSinResultados] = useState(false)

  const fetchPresupuestos = async () => {
    const { data } = await presupuestosService.buscarPorVendedor(
      parseInt(localStorage.getItem('idUsuario'))
    )
    setPresupuestos(data)
    setSinResultados(data.length === 0)
  }

  useEffect(() => {
    fetchPresupuestos()
  }, [])

  return (
    <>
      <MenuFiltros idComponente={20} />
      <BordePrincipal titulo="Mis Presupuestos">
        {!sinResultados ? (
          presupuestos.map((presupuesto) => (
            <Fragment key={presupuesto.idPresupuesto}>
              <Presupuesto presupuesto={presupuesto} canAdministrate={true} />
            </Fragment>
          ))
        ) : (
          <div className="row">
            <ComponenteError tipo="I" idAviso={20} />
          </div>
        )}
      </BordePrincipal>
    </>
  )
}

Presupuestos.propTypes = {
  onToggleClick: PropTypes.func.isRequired
}

export default Presupuestos
